import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { AuditEventDetailsType } from '@/types/auditLogTypes';

export const getAuditEventApi = (id: string): Promise<ApiResponseType<AuditEventDetailsType>> => {
  return authApiService.GET(`/audit-log/events/${id}/`);
};
